import logger from '../utils/logger';

export class MagicLinkStore {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_APP_BASE_SERVER_URL || 'http://localhost:3000';
  }

  public async requestMagicLink(email: string): Promise<{ message: string }> {
    const url = `${this.baseUrl}/auth/magic-link`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      return await response.json();
    } catch (error) {
      logger.error('Magic link request failed', {
        error: error instanceof Error ? error.message : String(error),
      });
      throw error;
    }
  }

  /**
   * Signs in with a magic link token. The API sets the session cookies on this response and returns where
   * to go next; called from the app rather than via redirect so privacy-focused browsers keep the cookies.
   */
  public async verifyMagicLink(token: string): Promise<{ redirectTo: string }> {
    const url = `${this.baseUrl}/auth/verify-magic-link`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ token }),
      });
      if (!response.ok) {
        throw new Error(`Magic link sign-in failed with status ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      logger.error('Magic link sign-in failed', {
        error: error instanceof Error ? error.message : String(error),
      });
      throw error;
    }
  }
}
